import React from 'react';

import {HStack, Heading, Text, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useSalesmanContext} from '../../../../../context/salesman';
import InternalTemplate from '../../../../../components/templates/internal';
import {StackParamList} from '../../../../../navigators';
import {message as t} from '../../../../../utils/messages';
import {PrimaryButton} from '../../../../../components/buttons';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanScheduleDetail'
>;

const SalesmanScheduleDetailScreen = ({navigation}: ScreenProps) => {
  const {appointment} = useSalesmanContext();

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const formatMonth = (month: number) => {
    return month < 10 ? `0${month}` : month;
  };

  const formatHour = (hour: number, minute: number) => {
    const meridiamLapse = hour > 12 ? 'PM' : 'AM';
    const meridiamTime = hour > 12 ? hour - 12 : hour;
    const meridiamTimeTwoDigits =
      meridiamTime < 10 ? `0${meridiamTime}` : `${meridiamTime}`;

    const minuteTwoDigits = minute < 10 ? `0${minute}` : `${minute}`;

    return `${meridiamTimeTwoDigits}:${minuteTwoDigits} ${meridiamLapse}`;
  };

  const handleOnPressConfirmation = () => {
    navigation.navigate('ScheduleCodeScanner');
  };

  return (
    <InternalTemplate
      title={'salesman-schedule-detail-title'}
      contentPaddingX="0"
      fixed={true}
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <VStack flex={1} paddingX={5}>
        <HStack backgroundColor={'#FFFFFF'} paddingY={3}>
          <Heading
            fontSize={16}
            fontWeight={'bold'}
            color="#06355E"
            width={100}
            marginLeft={5}>
            {t('salesman-schedule-detail-client-label')}
          </Heading>
          <Text fontSize={16} color="#06355E" marginRight={5} flex="1">
            {appointment?.customer.name}
          </Text>
        </HStack>
        <HStack
          backgroundColor={'#F8F8F8'}
          justifyContent={'space-between'}
          paddingY={3}>
          <Heading
            fontSize={16}
            fontWeight={'bold'}
            color="#06355E"
            width={100}
            marginLeft={5}>
            {t('salesman-schedule-detail-date-label')}
          </Heading>
          <Text fontSize={16} color="#06355E" marginRight={5} flex="1">
            {`${appointment?.date.day}-${formatMonth(
              appointment?.date.month!,
            )}-${appointment?.date.year}`}
          </Text>
        </HStack>
        <HStack
          backgroundColor={'#FFFFFF'}
          justifyContent={'space-between'}
          paddingY={3}>
          <Heading
            fontSize={16}
            fontWeight={'bold'}
            color="#06355E"
            width={100}
            marginLeft={5}>
            {t('salesman-schedule-detail-horary-label')}
          </Heading>
          <Text fontSize={16} color="#06355E" marginRight={5} flex="1">
            {formatHour(appointment?.date.hour!, appointment?.date.minute!)}
          </Text>
        </HStack>
        <HStack
          backgroundColor={'#F8F8F8'}
          justifyContent={'space-between'}
          paddingY={3}>
          <Heading
            fontSize={16}
            fontWeight={'bold'}
            color="#06355E"
            width={100}
            marginLeft={5}>
            {t('salesman-schedule-detail-subject-label')}
          </Heading>
          <Text fontSize={16} color="#06355E" marginRight={5} flex="1">
            {appointment?.subject}
          </Text>
        </HStack>
        <HStack
          backgroundColor={'#FFFFFF'}
          justifyContent={'space-between'}
          paddingY={3}
          marginBottom={50}>
          <Heading
            fontSize={16}
            fontWeight={'bold'}
            color="#06355E"
            width={100}
            marginLeft={5}>
            {t('salesman-schedule-detail-notes-label')}
          </Heading>
          <Text fontSize={16} color="#06355E" marginRight={5} flex="1">
            {appointment?.summary}
          </Text>
        </HStack>
        <PrimaryButton
          label="salesman-schedule-detail-confirm-label"
          onPress={handleOnPressConfirmation}
        />
      </VStack>
    </InternalTemplate>
  );
};
export default SalesmanScheduleDetailScreen;
